
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree61d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree61d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("F8oyc", function(module, exports) {
$parcel$export(module.exports, "register", () => $07ba578472346502$export$6503ec6e8aabbaf, (v) => $07ba578472346502$export$6503ec6e8aabbaf = v);
var $07ba578472346502$export$6503ec6e8aabbaf;
var $07ba578472346502$export$f7ad0328861e2f03;
"use strict";
var $07ba578472346502$var$mapping = new Map();
function $07ba578472346502$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$07ba578472346502$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $07ba578472346502$var$resolve(id) {
    var resolved = $07ba578472346502$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$07ba578472346502$export$6503ec6e8aabbaf = $07ba578472346502$var$register;
$07ba578472346502$export$f7ad0328861e2f03 = $07ba578472346502$var$resolve;

});

var $10da5ee999a8a7c1$exports = {};

(parcelRequire("F8oyc")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"duP06\",\"index.d1676904.js\",\"g5ayN\",\"cookies-history.a2fb9675.jpeg\",\"fGzRd\",\"macaroons.ff0f1526.jpeg\",\"1NdcG\",\"cookies-lover.60ddb270.gif\",\"1gQs6\",\"recipes-cookies-1.7b3434f9.jpeg\",\"8hsBo\",\"recipes-cookies-2.3482d22c.jpeg\",\"e0VD9\",\"recipes-cookies-3.684ec5b1.jpeg\",\"i56lW\",\"recipes-cookies-4.a625a530.jpeg\",\"cxodS\",\"recipes-cookies-5.f342ae46.jpeg\",\"6auTw\",\"index.f5a2d8d2.css\"]"));


//# sourceMappingURL=index.runtime.0a12ee4f.js.map
